import { render, staticRenderFns } from "./labelImportRecord.vue?vue&type=template&id=040f1564&scoped=true"
import script from "./labelImportRecord.vue?vue&type=script&lang=js"
export * from "./labelImportRecord.vue?vue&type=script&lang=js"
import style0 from "./labelImportRecord.vue?vue&type=style&index=0&id=040f1564&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040f1564",
  null
  
)

export default component.exports